import Vue from 'vue';

var tool = {
    methods: {
        showMsg(text) {
            return this.$message({
                showClose: true,
                message: text,
                type: 'warning'
            });
        },
        successMsg(text) {
            return this.$message({
                showClose: true,
                message: text,
                type: 'success'
            });
        },
        errorMsg(text) {
            return this.$message({
                showClose: true,
                message: text,
                type: 'error',
                duration: 9000
            });
        },
        confirm(text, callback) {
            this.$confirm(text, '提示', {
                type: 'warning'
            }).then(() => {
                callback();
            }).catch(error => console.log(error));
        }
    }
};

Vue.mixin(tool);



// WEBPACK FOOTER //
// ./src/common/js/tool.js